export const GET_REF = "GET_REF";
export const SET_REF = "SET_REF";
export const GET_REF_SUCCESS = "GET_REF_SUCCESS";
